import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import StatusViewEditComponent from "../../components/statusViewEditComponent";
import { toast } from "react-toastify";
import DeleteModal from "../../../../../Components/Common/DeleteModal";

import {
  createFoodAllergen,
  createFoodAllergenSuccess,
  deleteFoodAllergen,
  deleteFoodAllergenSuccess,
  getFoodAllergenList,
  updateFoodAllergen,
  updateFoodAllergenSuccess,
} from "../../../../../store/products/action";

export default function FoodAllergen() {
  const dispatch = useDispatch();
  const { foodAllergenListSuccessAPI } = useSelector((state) => ({
    foodAllergenListSuccessAPI:
      state.Products.foodAllergenList?.foodallergen_list,
  }));

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [statusFlag, setStatusFlag] = useState(false);
  const [createStatus, setCreateStatus] = useState({
    Name: "New Allergen",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      dispatch(createFoodAllergen([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = foodAllergenListSuccessAPI?.sort(
        (a, b) => b.Id - a.Id
      );
    }

    setStatusList(data);
  }, [foodAllergenListSuccessAPI, activeTab]);

  useEffect(() => {
    dispatch(getFoodAllergenList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      dispatch(deleteFoodAllergen([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,

    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        dispatch(updateFoodAllergen([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    createFoodAllergenSuccessAPI,
    updateFoodAllergenSuccessAPI,
    deleteFoodAllergenSuccessAPI,
  } = useSelector((state) => ({
    createFoodAllergenSuccessAPI:
      state.Products.createFoodAllergenSuccess,
    updateFoodAllergenSuccessAPI:
      state.Products.updateFoodAllergenSuccess,
    deleteFoodAllergenSuccessAPI:
      state.Products.deleteFoodAllergenSuccess,
  }));

  // Add New response
  useEffect(() => {
    if (isEmpty(createFoodAllergenSuccessAPI)) return;
    if (createFoodAllergenSuccessAPI?.status === 200) {
      toast.success(createFoodAllergenSuccessAPI?.message);
      dispatch(getFoodAllergenList());
    } else {
      toast.error(createFoodAllergenSuccessAPI?.message);
    }
    dispatch(createFoodAllergenSuccess([]));
  }, [createFoodAllergenSuccessAPI]);

  // Update response
  useEffect(() => {
    if (isEmpty(updateFoodAllergenSuccessAPI)) return;
    if (updateFoodAllergenSuccessAPI?.status === 200) {
      toast.success(updateFoodAllergenSuccessAPI?.message);
      dispatch(getFoodAllergenList());
    } else {
      toast.error(updateFoodAllergenSuccessAPI?.message);
    }
    dispatch(updateFoodAllergenSuccess([]));
  }, [updateFoodAllergenSuccessAPI]);

  // Delete response
  useEffect(() => {
    if (isEmpty(deleteFoodAllergenSuccessAPI)) return;
    if (deleteFoodAllergenSuccessAPI?.status === 200) {
      toast.success(deleteFoodAllergenSuccessAPI?.message);
      dispatch(getFoodAllergenList());
      setDeleteModal(false);
    } else {
      toast.error(deleteFoodAllergenSuccessAPI?.message);
    }
    dispatch(deleteFoodAllergenSuccess([]));
  }, [deleteFoodAllergenSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}
      <Row className="row align-items-end mt-3"></Row>
      <Row>
        <Col lg={12}>
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            statusFlag={statusFlag}
          />
        </Col>
      </Row>
    </>
  );
}
